import { Link } from "react-router-dom";

export default function Banner() {
  return (
    <section
      className="text-white d-flex align-items-center"
      style={{
        minHeight: "70vh", // ⬅️ controls banner height
        backgroundImage:
          "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('/asset/images/banner.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="col-lg-7">
          <h1 className="display-5 fw-bold">
            Professional React Development
          </h1>

          <p className="lead mt-3">
            Clean architecture, modern tooling, and scalable UI design.
          </p>

          <Link to="/register" className="btn custom-btn mt-3">
            Get Started
          </Link>
        </div>
      </div>
    </section>
  );
}
